// Project custom JS
if(document.querySelector('body.template-product')){
    document.addEventListener('DOMContentLoaded', () => {
        // Run only on product pages where the variant picker exists
        const variantOptions = document.querySelector('variant-options.wt-variant-options');

        const url = new URL(window.location.href);
        const variantParam = url.searchParams.get('variant');
        
        if (!variantOptions) return;

        // If URL already has a variant, do nothing
        if (variantParam) return;

        // Get variants JSON from the inline script inside variant-options
        const variantsScript = variantOptions.querySelector('script[type="application/json"]');
        if (!variantsScript) return;

        let variants = [];
        try {
            variants = JSON.parse(variantsScript.textContent);
        } catch (error) {
            console.error('Could not parse variants JSON:', error);
            return;
        }

        if (!Array.isArray(variants) || !variants.length) return;

        // Find first available variant
        const firstAvailableVariant = variants.find(variant => variant.available);
        if (!firstAvailableVariant) return;

        // Build selected option values array
        const selectedOptions = [
            firstAvailableVariant.option1,
            firstAvailableVariant.option2,
            firstAvailableVariant.option3
        ].filter(Boolean);

        // Select matching radio inputs by option name/value order
        const fieldsets = variantOptions.querySelectorAll('fieldset.product-form__input');

        fieldsets.forEach((fieldset, index) => {
            const targetValue = selectedOptions[index];
            if (!targetValue) return;

            const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
            radio => radio.value === targetValue
            );

            if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        
    });
}
